import apiSlice from './ApiSlice';
export const goalApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // GET
        getGoals: builder.query({
            providesTags: ["goal"],
            query: (body) => {
                return {
                    url: "/goal",
                    method: "POST",
                    body,
                };
            },
        }),
        // ADD
        addGoals: builder.mutation({
            invalidatesTags: ["goal"],
            query: (body) => {
                return {
                    url: "/goal/add",
                    method: "POST",
                    body,
                };
            },
        }),
        // EDIT
        editGoals: builder.mutation({
            invalidatesTags: ["goal"],
            query: ({ body, goalId }: any) => {
                return {
                    url: `/goal/${goalId}`,
                    method: "PUT",
                    body,
                };
            },
        }),
        //Single View
        getGoalsById: builder.query({
            providesTags: ["goal"],
            query: (goalId: any) => {
                return {
                    url: `/goal/${goalId}`,
                    method: "GET",
                };
            },
        }),
        //Single View
        deleteGoal: builder.mutation({
            invalidatesTags: ["goal"],
            query: (goalId: any) => {
                return {
                    url: `/goal/${goalId}`,
                    method: "DELETE",
                };
            },
        }),
          //Add
    addAchivement: builder.mutation({
        invalidatesTags: ["goal"],
        query: (body) => {
          return {
            url: "/goal-achieve/add",
            method: "POST",
            body,
          };
        },
      }),
       //Get goal-s by ID
    getGoalsByIdView: builder.query({
        providesTags: ["goal"],
        query: (id) => {
          return {
            url: `/goal/${id}`,
            method: "GET",
          };
        },
      }),
      // goal achive
      getGoalsAchivement: builder.query({
        providesTags: ["goal"],
        query: (body) => {
          return {
            url: "/goal-achieve/",
            method: "POST",
            body,
          };
        },
      }),

    }),
});

export const { useGetGoalsQuery, useAddGoalsMutation, useEditGoalsMutation, useGetGoalsByIdQuery,useDeleteGoalMutation,useAddAchivementMutation,useGetGoalsByIdViewQuery,useGetGoalsAchivementQuery } = goalApi;